import { Icon, Modal, Typography } from '@aloft/toolkit-sui';
import { Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui/chakra';

export const ValuationTablePropertyHeaderMenu = ({
  handleLeftButtonClick,
  handleRightButtonClick,
  DeleteConfirmationModal,
}: {
  handleLeftButtonClick?: () => void;
  handleRightButtonClick?: () => void;
  DeleteConfirmationModal: {
    Modal: typeof Modal;
    isModalOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
  };
}) => {
  return (
    <Menu placement="bottom-end">
      <MenuButton>
        <Icon icon="more-2" size="md" color="strokeActive" />
      </MenuButton>
      <MenuList minWidth={'100px'}>
        <MenuItem onClick={DeleteConfirmationModal.openModal} width={'150px'}>
          <Typography>Delete</Typography>
        </MenuItem>
        {handleLeftButtonClick && (
          <MenuItem onClick={handleLeftButtonClick} width={'150px'}>
            <Typography>Move Left</Typography>
          </MenuItem>
        )}
        {handleRightButtonClick && (
          <MenuItem onClick={handleRightButtonClick} width={'150px'}>
            <Typography>Move Right</Typography>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};
